import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppRoutesName } from '../../const/AppRoutesName';
import { CanDeactivateGuard } from '../../gards/can-deactivate-guard.service';

export const routes: Routes = [
  {
    path: ':shop_uuid/' + AppRoutesName.FR.ORDER,
    loadComponent: () =>
      import('./order.component').then((m) => m.OrderComponent),
    canDeactivate: [CanDeactivateGuard],
  },
  {
    path: ':shop_uuid/' + AppRoutesName.FR.PROPOSITION,
    loadComponent: () =>
      import('./order.component').then((m) => m.OrderComponent),
    canDeactivate: [CanDeactivateGuard],
  },
  {
    path: ':shop_uuid/' + AppRoutesName.FR.INVOICE,
    loadComponent: () =>
      import('./order.component').then((m) => m.OrderComponent),
    canDeactivate: [CanDeactivateGuard],
  },
  {
    path: ':shop_uuid/' + AppRoutesName.EN.ORDER,
    loadComponent: () =>
      import('./order.component').then((m) => m.OrderComponent),
    canDeactivate: [CanDeactivateGuard],
  },
  {
    path: ':shop_uuid/' + AppRoutesName.EN.PROPOSITION,
    loadComponent: () =>
      import('./order.component').then((m) => m.OrderComponent),
    canDeactivate: [CanDeactivateGuard],
  },
  {
    path: ':shop_uuid/' + AppRoutesName.EN.INVOICE,
    loadComponent: () =>
      import('./order.component').then((m) => m.OrderComponent),
    canDeactivate: [CanDeactivateGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OrdersModule {}
